function stableKeysOrderReplacer(_key, value) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
        const keys = Object.keys(value).sort();
        const length = keys.length;
        const result = {};
        for(let i = 0; i < length; i++){
            result[keys[i]] = value[keys[i]];
        }
        return result;
    }
    return value;
}
export default function stringifyGraphQlVars(value) {
    return JSON.stringify(value, stableKeysOrderReplacer);
}

//# sourceMappingURL=stringifyGraphQlVars.js.map